import { render, staticRenderFns } from "./DashboardFeaturePanelContainer.vue?vue&type=template&id=05c266b5&scoped=true&"
import script from "./DashboardFeaturePanelContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardFeaturePanelContainer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeaturePanelContainer.vue?vue&type=style&index=0&id=05c266b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c266b5",
  null
  
)

export default component.exports